// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-list-sorting-switch__popover--selected{color:var(--jw-color-primary)}.title-list-sorting-switch__popover--selected .vfm-item{color:inherit!important}.title-list-sorting-switch__popover .vfm-item{padding:14px;font-size:16px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
